var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getSession } from '@/common/utils/tools';
// import { targetTenantCheck } from '@/common/api/common';
import { curTenantInfo, getAreaList, getCurrentUser, getMenuList, targetTenantCheck } from '@/common/api/common';
import { isArray } from '@lhb/func';
import { isNotEmpty } from '@lhb/func';
import { LOCXX_TASK_TEMPLATE_CODE } from '@/views/standardstore/common/locxx-task';
export default {
    state: {
        keepAlivePages: [],
        /** 当前租户检查信息 tenantCheckInfo  */
        targetTenant: null,
        useInfo: null,
        menuList: null,
        provinceCityDistrict: [],
        // provincesCities: [], // 省市
        // 专供高德地图的城市数据，数据格式
        cityForAMap: [],
        tenantInfo: null,
        /** 当前租户的拓店任务模板 */
        taskTemplateCode: null,
        /** 消息深链临时指定的任务模板，不修改租户模板本体。 */
        routeTaskTemplateCode: null,
        /** 是否需要在返回上一页时刷新当前页面 */
        needRefreshOnBack: false,
        /** 滚动位置缓存，格式：{ [key: string]: { scrollTop: number, scrollLeft: number } } */
        scrollStates: {},
    },
    actions: {
        /** 获取当前租户检查信息 tenantCheckInfo */
        $_GetTargetTenant: function (_a) {
            var commit = _a.commit, state = _a.state;
            if (state.targetTenant) {
                return Promise.resolve(state.targetTenant);
            }
            else {
                return new Promise(function (resolve, reject) {
                    targetTenantCheck().then(function (res) {
                        var data = res === null || res === void 0 ? void 0 : res.data;
                        if (!data)
                            return;
                        commit('UPDATE_TARGET_TENANT', data);
                        resolve(data);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
        /** 获取当前用户信息 */
        $_CurrentUserInfo: function (_a) {
            var commit = _a.commit, state = _a.state;
            if (state.useInfo) {
                return Promise.resolve(state.useInfo);
            }
            else {
                return new Promise(function (resolve, reject) {
                    getCurrentUser().then(function (res) {
                        var data = res === null || res === void 0 ? void 0 : res.data;
                        data && commit('UPDATE_CURRENT_USER', data);
                        resolve(data);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
        // 获取当前菜单列表
        $_GetMenuList: function (_a) {
            var commit = _a.commit, state = _a.state;
            if (state.menuList) {
                return Promise.resolve(state.menuList);
            }
            else {
                return new Promise(function (resolve, reject) {
                    getMenuList().then(function (res) {
                        var data = (res === null || res === void 0 ? void 0 : res.data) || [];
                        commit('UPDATE_MENU_LIST', data);
                        resolve(data);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
        // 获取省市区数据
        $_AreaList: function (_a) {
            var commit = _a.commit, state = _a.state;
            if (isArray(state.provinceCityDistrict) && state.provinceCityDistrict.length) {
                return Promise.resolve(state.provinceCityDistrict);
            }
            else {
                return new Promise(function (resolve, reject) {
                    getAreaList().then(function (data) {
                        if (!isArray(data))
                            return;
                        var _cityForAMap = [];
                        var targetData = data.map(function (item) {
                            var _a, _b, _c;
                            if (['台湾', '香港', '澳门'].some(function (region) { return item.name.indexOf(region) !== -1; })) {
                                (_a = item.children) === null || _a === void 0 ? void 0 : _a.forEach(function (city) {
                                    var _a;
                                    city.disabled = true;
                                    (_a = city.children) === null || _a === void 0 ? void 0 : _a.forEach(function (district) {
                                        district.disabled = true;
                                    });
                                });
                                // cityForAMap数据组装
                                (_b = item.children) === null || _b === void 0 ? void 0 : _b.forEach(function (city) {
                                    _cityForAMap.push({
                                        name: city.name,
                                        id: city.id,
                                        provinceName: item.name,
                                        provinceId: item.id,
                                        district: city.children,
                                        disabled: true
                                    });
                                });
                                return __assign(__assign({}, item), { disabled: true });
                            }
                            // cityForAMap数据组装
                            (_c = item.children) === null || _c === void 0 ? void 0 : _c.forEach(function (city) {
                                _cityForAMap.push({
                                    name: city.name,
                                    id: city.id,
                                    provinceName: item.name,
                                    provinceId: item.id,
                                    district: city.children
                                });
                            });
                            return item;
                        });
                        commit('UPDATE_PCD_DATA', targetData);
                        commit('UPDATE_AMAP_CITY', _cityForAMap);
                        resolve(data);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
        // 获取当前租户信息
        $_GetTenantInfo: function (_a) {
            var commit = _a.commit, state = _a.state;
            if (state.tenantInfo) {
                return Promise.resolve(state.tenantInfo);
            }
            else {
                return new Promise(function (resolve, reject) {
                    curTenantInfo().then(function (res) {
                        var data = res === null || res === void 0 ? void 0 : res.data;
                        if (!data)
                            return;
                        commit('UPDATE_TENANT_INFO', data);
                        resolve(data);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
        /** 获取当前租户的拓店任务模板 */
        getTaskTemplateCode: function (_a) {
            var _b, _c;
            var commit = _a.commit, state = _a.state;
            if ((_b = state.targetTenant) === null || _b === void 0 ? void 0 : _b.taskTemplateCode) {
                commit('UDPATE_TASK_TEMPLATE_CODE', state.targetTenant.taskTemplateCode);
                return Promise.resolve((_c = state.targetTenant) === null || _c === void 0 ? void 0 : _c.taskTemplateCode);
            }
            else if (state.taskTemplateCode) {
                return Promise.resolve(state.taskTemplateCode);
            }
            else {
                return new Promise(function (resolve, reject) {
                    targetTenantCheck().then(function (res) {
                        var _a;
                        var _taskTemplateCode = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.taskTemplateCode) || '';
                        // const _taskTemplateCode = 'clusterC' || res?.data?.taskTemplateCode || '';
                        // const _taskTemplateCode = 'standardA' || res?.data?.taskTemplateCode || '';
                        commit('UDPATE_TASK_TEMPLATE_CODE', _taskTemplateCode);
                        resolve(_taskTemplateCode);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
    },
    mutations: {
        /** 清除滚动缓存 */
        CLEAR_SCROLL_STATE: function (state, key) {
            Reflect.deleteProperty(state.scrollStates, key);
        },
        /** 更新滚动缓存 */
        UPDATE_SCROLL_STATE: function (state, payload) {
            state.scrollStates[payload.key] = {
                scrollTop: payload.scrollTop,
                scrollLeft: payload.scrollLeft
            };
        },
        // 整个的set 缓存页面
        SET_KEEP_ALIVE_PAGES: function (state, val) {
            state.keepAlivePages = val;
        },
        // push 一个缓存页面
        PUSH_KEEP_ALIVE_PAGES: function (state, pageName) {
            if (state.keepAlivePages.includes(pageName)) {
                console.log('此页面已在缓存中');
            }
            else {
                state.keepAlivePages.push(pageName);
            }
        },
        REMOVE_KEEP_ALIVE_PAGES: function (state, pageName) {
            var index = state.keepAlivePages.findIndex(function (item) {
                return item === pageName;
            });
            if (index !== -1) {
                state.keepAlivePages.splice(index, 1);
            }
            else {
                console.log('该页面未被缓存');
            }
        },
        UPDATE_TARGET_TENANT: function (state, target) {
            state.targetTenant = target;
        },
        UPDATE_CURRENT_USER: function (state, target) {
            state.useInfo = target;
        },
        UPDATE_MENU_LIST: function (state, target) {
            state.menuList = target;
        },
        UPDATE_PCD_DATA: function (state, target) {
            state.provinceCityDistrict = target;
        },
        UPDATE_AMAP_CITY: function (state, target) {
            state.cityForAMap = target;
        },
        UPDATE_TENANT_INFO: function (state, target) {
            state.tenantInfo = target;
        },
        /** 更新当前租户的拓店任务模板 */
        UDPATE_TASK_TEMPLATE_CODE: function (state, target) {
            state.taskTemplateCode = target;
        },
        /** 设置或清除当前路由的临时任务模板。 */
        UPDATE_ROUTE_TASK_TEMPLATE_CODE: function (state, target) {
            state.routeTaskTemplateCode = target || null;
        },
        /** 是否需要刷新列表（再返回上一页时） */
        SET_NEED_REFRESH_ON_BACK: function (state, target) {
            state.needRefreshOnBack = !!target;
        },
    },
    getters: {
        effectiveTaskTemplateCode: function (state) {
            return state.routeTaskTemplateCode || state.taskTemplateCode;
        },
        getTaskTemplateType: function (state) {
            var _a;
            return ((_a = state === null || state === void 0 ? void 0 : state.tenantInfo) === null || _a === void 0 ? void 0 : _a.taskTemplateType) || '';
        },
        getIsBack: function (state) {
            return state.isBack || getSession('isBack');
        },
        /**
         * 当前租户的拓店任务模板是否加盟商模式A拓店任务
         * @description 未确定时为 null，确定后为 true/false
         * 相当于 旧的 isCircleTask
         */
        isStandardATaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['standardA'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否 Locxx。
         * @description 未确定时为 null，确定后为 true/false
         */
        isLocxxTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return getters.effectiveTaskTemplateCode === LOCXX_TASK_TEMPLATE_CODE;
        },
        /**
         * 当前租户的拓店任务模板是否加盟商拓店任务模板B
         * @description 未确定时为 null，确定后为 true/false
         */
        isStandardBTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['standardB'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否加盟商拓店任务模板C
         * @description 未确定时为 null，确定后为 true/false
         */
        isStandardCTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['standardC'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否直营拓店任务
         * @description 未确定时为 null，确定后为 true/false
         * 相当于 旧的 isCircleTask
         */
        isClusterTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['clusterA', 'clusterB'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否“加盟+直营A（基诺浦）”
         * @description 未确定时为 null，确定后为 true/false
         */
        isStandardAndClusterATaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['standardAndClusterA'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否“加盟+直营B（一鸣）”
         * @description 未确定时为 null，确定后为 true/false
         */
        isStandardAndClusterBTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['standardAndClusterB'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否商圈拓店任务（指含有商圈的模板任务）
         * @description 未确定时为 null，确定后为 true/false
         * 不是 isCircleTask
         */
        isCircleTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['standardAndClusterA', 'standardAndClusterB', 'clusterA', 'clusterB', 'clusterC'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否森马拓店任务
         * @description 未确定时为 null，确定后为 true/false
         */
        isSenmaTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['clusterC'].includes(getters.effectiveTaskTemplateCode);
        },
        /**
         * 当前租户的拓店任务模板是否卡旺卡拓店任务
         * @description 未确定时为 null，确定后为 true/false
         */
        isKwkTaskTemplate: function (state, getters) {
            if (!isNotEmpty(getters.effectiveTaskTemplateCode)) {
                return null;
            }
            return ['clusterB'].includes(getters.effectiveTaskTemplateCode);
        },
    }
};
